import {Point} from 'chart.js';

/**
 * Function to calculate a simple moving average
 * @param {Point[]} data - The original data array of Point objects
 * @param {number} count - The period or range of values to average to create each point in the resulting array
 * @returns {Point[]} An array of moving averages as Point objects
 */
export function avgDataCalc(data: Point[], count: number = 3): Point[] {
	let result: Point[] = [];
	for (let i = 0; i <= data.length - count; i++) {
		let sum = 0;
		for (let j = 0; j < count; j++) {
			sum += data[i + j].y;
		}

		result.push({
						x: data[i].x,
						y: sum / count
					});
	}
	return result;
}